const SUPPORTED_IMAGE_FORMATS = new Set(['jpg', 'jpeg', 'png', 'webp']);
const IMAGE_EXTENSION_PATTERN = /\.([a-z0-9]+)(?:$|:)/;

export function isSupportedImageUrl(url: string | null | undefined): boolean {
  if (!url) {
    return false;
  }

  const trimmed = url.trim();
  if (trimmed.length === 0) {
    return false;
  }

  try {
    const parsed = new URL(trimmed);
    const pathname = parsed.pathname.toLowerCase();
    const extensionMatch = pathname.match(IMAGE_EXTENSION_PATTERN);
    const extension = extensionMatch?.[1]?.toLowerCase();
    if (extension && SUPPORTED_IMAGE_FORMATS.has(extension)) {
      return true;
    }

    const format = parsed.searchParams.get('format')?.toLowerCase();
    if (format && SUPPORTED_IMAGE_FORMATS.has(format)) {
      return true;
    }
  } catch {
    const normalized = trimmed.toLowerCase();
    const extension = normalized.split('?')[0]?.split('.').pop();
    if (extension && SUPPORTED_IMAGE_FORMATS.has(extension)) {
      return true;
    }
  }

  return false;
}
